import SelectPickupMarker from '../../../../assets/select-pickup-marker.svg';
import { FunctionComponent, h } from 'preact';
import classNames from 'classnames';

export interface Props {
	position: number;
	withOpacity?: boolean;
}

const AddressIcon: FunctionComponent<Props> = ({ position, withOpacity }) => {
	return (
		<span className="address-icon" aria-hidden="true">
			<img src={SelectPickupMarker} className={classNames('icon', { 'icon-with-opacity': withOpacity })} />
			<span className="position-text">{position}</span>
		</span>
	);
};

export default AddressIcon;
